import { SimpleHouseType } from "./estateInterfaces";

export const VALID_HOUSE_TYPES = [
  SimpleHouseType.DETACHED_HOUSE,
  SimpleHouseType.SEMI_DETACHED_HOUSE,
  SimpleHouseType.UNDETACHED_HOUSE,
];
